import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const MAX_WORKLOAD_AUTOSCALING_RANGE_HOURS = 192;

dayjs.extend(utc);

export const capWorkloadAutoscalingRange = ({
  from,
  to,
}: {
  from: string;
  to: string;
}): { from: string; to: string } => {
  const now = dayjs.utc();
  const fromDate = dayjs(from).isAfter(now) ? now : dayjs(from);
  const toDate = dayjs(to).isAfter(now) ? now : dayjs(to);
  const diffHours = toDate.diff(fromDate, 'hour', true);

  if (diffHours <= MAX_WORKLOAD_AUTOSCALING_RANGE_HOURS) {
    return {
      from: fromDate.toISOString(),
      to: toDate.toISOString(),
    };
  }

  return {
    from: toDate
      .subtract(MAX_WORKLOAD_AUTOSCALING_RANGE_HOURS, 'hours')
      .toISOString(),
    to: toDate.toISOString(),
  };
};
